<iframe
  #iframe
  frameborder="0"
  *ngIf="state.vsCodeUrl"
  [src]="state.vsCodeUrl"
  [style.pointer-events]="state.iframePointerEvents"
  (load)="iframeLoaded$.next($event)"
></iframe>

<div *ngIf="state.isLoading" class="loader absolute">
  <y42-logo-loader class="center-absolute"></y42-logo-loader>
</div>
